<template>
  <div>
    <pageTable ref="table" :tableTitle="tableColumn" :searchData="searchData" :defaultPageSize="20" :pageSizeOptions="[20,50,100]" tableApi="admin/company/getCompanyLists"
      :showSearchForm="!searchData.days_since_last">
      <template v-slot:searchFormItem>
        <FormItem prop="company_id">
          <Input type="text" v-model="searchData.company_id" placeholder="ID" class="lx-search-item"
            style="width: 120px;"></Input>
        </FormItem>
        <FormItem prop="company_name">
          <Input type="text" v-model="searchData.company_name" placeholder="名称" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="manager_name">
          <Input type="text" v-model="searchData.manager_name" placeholder="联系人姓名或手机或业务员"
            class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="days_since_last">
          <Input type="text" v-model="searchData.days_since_last" placeholder="最后加油距今天天数"
            class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="date">
          <DatePicker v-model="searchData.date" type="date" placeholder="计算余额截至日期" class="lx-search-item"
            style="width: 180px;" />
        </FormItem>
        <FormItem prop="is_del">
          <Select v-model="searchData.is_del" placeholder="状态" clearable>
            <Option value="0">正常</Option>
            <Option value="1">禁用</Option>
            <Option value="">全部</Option>
          </Select>
        </FormItem>
        <FormItem prop="sort_mode">
          <Select v-model="searchData.sort_mode" placeholder="排序方式" clearable style="width: 180px">
            <Option value="">默认排序</Option>
            <Option value="balance_asc_nonzero">余额升序(零余额置后)</Option>
          </Select>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem v-if="searchData.days_since_last">
          <Button type="primary" @click="$refs.table.getLists()" icon="ios-search">搜索</Button>
        </FormItem>
        <FormItem v-if="searchData.days_since_last">
          <Button type="primary" @click="$refs.table.resetSearchForm()">重置</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="edit(0)">添加</Button>
        </FormItem>

        <FormItem>
          <Button type="warning" @click="exportData">导出</Button>
        </FormItem>
      </template>
    </pageTable>

    <editForm v-if="showEditForm" :show-edit="showEditForm" :company-id="editCompanyId" ref="Edit"
      @cancel-edit="cancelEdit" @edit-success="editSuccess">
    </editForm>

    <Modal v-model="rechargeModal" :title="rechargeModalTitle" :loading="loadingRechargeModal" @on-ok="doRecharge"
      @on-cancel="cancelRechargeModal">
      <Row style="justify-content: center;">
        支付方式:{{ rechargeInfo.pay_type_name }}
        <Select v-model="rechargeInfo.pay_type" style="width: 120px;margin-left:10px">
          <Option value="litre">升数支付</Option>
          <Option value="amount">金额支付</Option>
        </Select>
        <Button type="primary" @click="changePayType">修改</Button>
      </Row>
      <Row style="justify-content: center;">
        单价：{{ rechargeInfo.unit_price }}
        车队卡余额：{{ rechargeInfo.company_balance }}
        车队余额：{{ rechargeInfo.card_balance }}
        <span v-if="editAfterCompanyBalance !== ''"> -> {{ editAfterCompanyBalance }}</span>
      </Row>
      <Form ref="rechargeForm" :label-width="100" :model="rechargeForm">
        <FormItem label="充值账户" prop="account_type"  v-if="inArray(rechargeForm.company_id, [509,691,692,694])">
          <Select v-model="rechargeForm.account_type" style="width: 160px">
<!--            <Option :value="1">主账户</Option>-->
            <Option :value="2">lng账户</Option>
            <Option :value="3">柴油账户</Option>
          </Select>
        </FormItem>

        <FormItem label="充值金额" prop="amount">
          <Input @on-change="countCompanyBalance" v-model="rechargeForm.amount" placeholder="请输入整数,正数添加余额，负数扣除余额"
            maxlength="100"></Input>
        </FormItem>
        <FormItem label="充值密码" prop="password">
          <Input v-model="rechargeForm.password" placeholder="" maxlength="100"></Input>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <div style="display: flex; align-items: center; width: 100%;">
            <Input v-model="rechargeForm.remark" placeholder="" maxlength="50" style="flex: 1;"></Input>
            <Button type="warning" size="small" style="margin-left: 8px; flex-shrink: 0;" @click="fillRemarkUnpaid">未付款</Button>
          </div>
        </FormItem>
      </Form>
    </Modal>

    <Drawer :title="snDrawerTitle" width="900" :value="isShowSnDrawer" :mask-closable="true" @on-close="closeSnDrawer">
      <CompanySn :company-id="snCompanyId" v-if="isShowSnDrawer"></CompanySn>
    </Drawer>

    <Drawer :title="pendingApplyModal.company_name + ' 待处理调价'" width="1600" :value="pendingApplyModal.isShow"
      :mask-closable="true" @on-close="closePendingApplyDrawer">
      <CompanyStation
        :company-id="pendingApplyModal.company_id"
        :partner-apply-status="1"
        :hide-price-columns="true"
        v-if="pendingApplyModal.isShow"
      ></CompanyStation>
    </Drawer>

    <Modal v-model="unitPriceModal.isShow" :title="unitPriceModal.title" :loading="unitPriceModal.isLoading"
      @on-ok="changeUnitPriceFixTime" @on-cancel="cancelUnitPriceModal">
      <Form ref="unitPriceForm" :label-width="100" :model="unitPriceForm">
        <FormItem label="单价" prop="unitPrice">
          <Input v-model="unitPriceForm.unitPrice" placeholder="" maxlength="100"></Input>
        </FormItem>
        <FormItem label="执行时间" prop="doTime">
          <DatePicker v-model="unitPriceForm.doTime" type="datetime" placeholder="不填写则表示立即修改" style="width: 200px" />
        </FormItem>
      </Form>
      <div v-if="scheduledUnitPriceChange && scheduledUnitPriceChange.do_time" style="margin-top:8px;padding:8px;border:1px dashed #e8e8e8;border-radius:4px;background:#fafafa">
        <p style="margin:0 6px 6px;color:#666;font-size:12px">已预约尚未执行的调价记录：<span style="color:#333;font-weight:500">{{ scheduledUnitPriceChange.do_time }}</span></p>
        <table style="width:100%;border-collapse:collapse;font-size:13px;color:#333">
          <thead>
            <tr>
              <th style="text-align:left;padding:6px;border-bottom:1px solid #eee">当前单价</th>
              <th style="text-align:left;padding:6px;border-bottom:1px solid #eee">预约单价</th>
              <th style="text-align:left;padding:6px;border-bottom:1px solid #eee">执行时间</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="padding:6px;border-bottom:1px solid #f5f5f5">{{ scheduledUnitPriceChange.old_unit_price }}</td>
              <td style="padding:6px;border-bottom:1px solid #f5f5f5">{{ scheduledUnitPriceChange.new_unit_price }}</td>
              <td style="padding:6px;border-bottom:1px solid #f5f5f5">{{ scheduledUnitPriceChange.do_time }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      
    </Modal>

    <!-- 自动调价规则弹窗 -->
    <Modal v-model="priceRuleModal.isShow" :title="priceRuleModal.title" :loading="priceRuleModal.isLoading"
      @on-ok="savePriceRule" @on-cancel="cancelPriceRuleModal" width="900">
      <div v-if="priceRuleModal.isLoading" style="text-align:center;padding:20px">保存中...</div>
      <div v-else>
        <Table :columns="[
          { title: '规则', key: 'name', align: 'left' },
          { title: '启用', key: 'enabled', align: 'center', render: (h, params) => { return h('i-switch', { props: { value: params.row.enabled }, on: { 'on-change': (val) => { const idx = this.priceRuleModal.list.findIndex(x => x.id === params.row.id); if (idx >= 0) this.$set(this.priceRuleModal.list[idx], 'enabled', val) } } }) } },
          {
            title: '参数', key: 'params', align: 'left', render: (h, params) => {
              const r = params.row;
              if (!r.enabled) return h('span', '');
              // 根据 id 渲染简单参数输入
              if ([1, 2].includes(r.id)) {
                return h('div', [
                  h('span', { style: { marginRight: '6px' } }, '油站'),
                  h('i-switch', {
                    props: { value: !!r.params.oil_enabled },
                    on: {
                      'on-change': (val) => {
                        const idx = this.priceRuleModal.list.findIndex(x => x.id === r.id);
                        if (idx >= 0) this.$set(this.priceRuleModal.list[idx], 'params', Object.assign({}, this.priceRuleModal.list[idx].params, { oil_enabled: val ? 1 : 0 }))
                      }
                    },
                    style: { marginRight: '12px' }
                  }),
                  h('span', { style: { marginRight: '6px' } }, '气站'),
                  h('i-switch', {
                    props: { value: !!r.params.lng_enabled },
                    on: {
                      'on-change': (val) => {
                        const idx = this.priceRuleModal.list.findIndex(x => x.id === r.id);
                        if (idx >= 0) this.$set(this.priceRuleModal.list[idx], 'params', Object.assign({}, this.priceRuleModal.list[idx].params, { lng_enabled: val ? 1 : 0 }))
                      }
                    }
                  }),
                ])
              } else if ([3].includes(r.id)) {
                return h('div', [
                  h('Input', {
                    props: { value: r.params.oil_add },
                    on: {
                      input: (v) => {
                        const idx = this.priceRuleModal.list.findIndex(x => x.id === r.id);
                        if (idx >= 0) this.$set(this.priceRuleModal.list[idx], 'params', Object.assign({}, this.priceRuleModal.list[idx].params, { oil_add: v }))
                      }
                    },
                    style: { width: '140px', marginRight: '6px' },
                    attrs: { placeholder: '油站加价' }
                  }, []),
                  h('Input', {
                    props: { value: r.params.lng_add },
                    on: {
                      input: (v) => {
                        const idx = this.priceRuleModal.list.findIndex(x => x.id === r.id);
                        if (idx >= 0) this.$set(this.priceRuleModal.list[idx], 'params', Object.assign({}, this.priceRuleModal.list[idx].params, { lng_add: v }))
                      }
                    },
                    style: { width: '140px' },
                    attrs: { placeholder: '气站加价' }
                  }, []),
                ])
              } else if ([8].includes(r.id)) {
                return h('div', [
                  h('Input', { props: { value: r.params.threshold }, on: { input: (v) => { const idx = this.priceRuleModal.list.findIndex(x => x.id === r.id); if (idx >= 0) this.$set(this.priceRuleModal.list[idx], 'params', Object.assign({}, this.priceRuleModal.list[idx].params, { threshold: v })) } }, style: { width: '120px', marginRight: '6px' }, attrs: { placeholder: 'X' } }, []),
                  h('Input', { props: { value: r.params.add }, on: { input: (v) => { const idx = this.priceRuleModal.list.findIndex(x => x.id === r.id); if (idx >= 0) this.$set(this.priceRuleModal.list[idx], 'params', Object.assign({}, this.priceRuleModal.list[idx].params, { add: v })) } }, style: { width: '120px' }, attrs: { placeholder: 'Y' } }, [])
                ])
              } else
              if ([6].includes(r.id)) {
                return h('div', [
                  h('Input', { props: { value: r.params.oil_add }, on: { input: (v) => { const idx = this.priceRuleModal.list.findIndex(x => x.id === r.id); if (idx >= 0) this.$set(this.priceRuleModal.list[idx], 'params', Object.assign({}, this.priceRuleModal.list[idx].params, { oil_add: v })) } }, style: { width: '120px', marginRight: '6px' }, attrs: { placeholder: '油站加价' } }, []),
                  h('Input', { props: { value: r.params.lng_add }, on: { input: (v) => { const idx = this.priceRuleModal.list.findIndex(x => x.id === r.id); if (idx >= 0) this.$set(this.priceRuleModal.list[idx], 'params', Object.assign({}, this.priceRuleModal.list[idx].params, { lng_add: v })) } }, style: { width: '120px' }, attrs: { placeholder: 'LNG加价' } })
                ])
              } else {
                return h('span', '-')
              }
            }
          }
        ]" :data="priceRuleModal.list" :border="true" />

        <Divider orientation="left">分段调价规则（支持多个优惠区间）</Divider>
        <div style="margin-bottom: 10px;">
          <span style="margin-right: 8px;">优惠基准：</span>
          <RadioGroup v-model="priceRuleModal.discountType" type="button" size="small">
            <Radio label="ndrc">挂牌价优惠（ndrc_price - 结算价）</Radio>
            <Radio label="station">油机价优惠（station_price - 结算价）</Radio>
          </RadioGroup>
        </div>
        <div style="margin-bottom: 10px;">
          <Button type="dashed" icon="md-add" @click="addRangeRule">新增区间</Button>
        </div>
        <div v-if="priceRuleModal.rangeRules.length === 0" style="color:#999;">未配置分段规则，系统将仅按上方基础规则执行。</div>
        <div v-for="(range, idx) in priceRuleModal.rangeRules" :key="idx" style="display:flex;align-items:center;margin-bottom:8px;gap:8px;">
          <span>区间</span>
          <Input v-model="range.min_discount" placeholder="下界(含)" style="width:120px" @input="onRangeInput(idx, 'min_discount', $event)" @on-blur="onRangeBlur(idx, 'min_discount')" />
          <span>≤ 优惠 &lt;</span>
          <Input v-model="range.max_discount" placeholder="上界(不含,空=无穷)" style="width:160px" @input="onRangeInput(idx, 'max_discount', $event)" @on-blur="onRangeBlur(idx, 'max_discount')" />
          <span>加价</span>
          <Input v-model="range.add_price" placeholder="统一加价" style="width:120px" @input="onRangeInput(idx, 'add_price', $event)" @on-blur="onRangeBlur(idx, 'add_price')" />
          <Input v-model="range.oil_add" placeholder="油站加价(可选)" style="width:140px" @input="onRangeInput(idx, 'oil_add', $event)" @on-blur="onRangeBlur(idx, 'oil_add')" />
          <Input v-model="range.lng_add" placeholder="LNG加价(可选)" style="width:140px" @input="onRangeInput(idx, 'lng_add', $event)" @on-blur="onRangeBlur(idx, 'lng_add')" />
          <Button type="error" ghost size="small" @click="removeRangeRule(idx)">删除</Button>
        </div>
      </div>
    </Modal>

    <Modal v-model="daohangModal.isShow" :title="daohangModal.title" :loading="daohangModal.isLoading"
      @on-ok="editDaohangNum" @on-cancel="cancelDaohangModal">
      <Form ref="unitPriceForm" :label-width="100" :model="daohangModal">
        <FormItem label="次数" prop="num">
          <Input v-model="daohangModal.num" placeholder="负数则减去次数" maxlength="100"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="unitPriceModals.isShow" :title="unitPriceModals.title" :loading="unitPriceModals.isLoading"
           @on-ok="balanceSecWrite" @on-cancel="cancelUnitPriceModals">
      <Form ref="unitPriceForm" :label-width="100" :model="unitPriceForm">
        <FormItem label="核销金额" prop="write_balance">
          <Input v-model="unitPriceForm.write_balance" placeholder="请输入核销金额" @input="onWriteBalanceInput" @on-blur="onWriteBalanceBlur"></Input>
        </FormItem>
      </Form>
    </Modal>
    <edit-form v-if="showEdit" :show-edit="showEdit" :id="editId" :type="stype" ref="editModel"
               @cancel-edit="closeEditDrawer" @edit-success="editSuccess">
    </edit-form>

    <!--    显示可加油站点列表-->
    <Drawer :title="companyStationModal.company_name" width="1600" :value="companyStationModal.isShow"
      :mask-closable="true" @on-close="companyStationModal.isShow = false">
      <CompanyStation :company-id="companyStationModal.company_id" v-if="companyStationModal.isShow"></CompanyStation>
    </Drawer>
    <Drawer :title="companyStationManageModal.company_name + ' 站点管理'" width="1000" :value="companyStationManageModal.isShow"
      :mask-closable="true" @on-close="companyStationManageModal.isShow = false">
      <CompanyStationManage :company-id="companyStationManageModal.company_id" v-if="companyStationManageModal.isShow"></CompanyStationManage>
    </Drawer>
    <!--    显示核销记录-->
    <Drawer :title="writeRecordModal.company_name" width="1600" :value="writeRecordModal.isShow"
            :mask-closable="true" @on-close="writeRecordModal.isShow = false" :company_id="writeRecordModal.company_id">
      <curtailTable
          ref="tables"
          :tableTitle="tableNew"
          :searchData="searchNew"
          :tableData="tableNewarr"
          tableApi="admin/company/getWriteRecord"
      >

        <template v-slot:searchFormItem>

          <FormItem prop="create_time">
            <DatePicker v-model="searchDatas.create_time" type="datetimerange" @on-change="timeChange" placeholder="时间" style="width: 320px"></DatePicker>
          </FormItem>
        </template>

      </curtailTable>

    </Drawer>


  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import editForm from "./edit";
  import CompanySn from './companySn'
  import CompanyStation from "./companyStation";
  import CompanyStationManage from "./companyStationManage";
  import XLSX from 'xlsx';
  import curtailTable from "@/components/table/curtailTable.vue";
  export default {
    name: "fleet",
    components:{curtailTable, CompanyStation, CompanyStationManage, pageTable,editForm,CompanySn},
    data() {
      return {
        showEditForm:false,
        editCompanyId:0,
        editAfterCompanyBalance:'',
        searchData: {
          is_del:'0',
          company_id: '',
          company_name: '',
          manager_name:'',
          date: '', // 截至日期 不影响车队列表 只影响 剩余数量中的余额
          days_since_last: '', // 最后加油距今天数
          sort_mode: '', // 排序方式：默认 / 余额升序(零余额置后)
        },
        unitPriceModals: {
          isShow: false,
          title: '',
          isLoading: false,
        },
        tableColumn: [
          {title: 'ID',key: 'company_id',align: "center"},
          {title: '公司名称',key: 'company_name',align: "center"},
          {title: '业务员',key: 'salesman',align: "center"},

          {title: '最后加油距今天数', key: 'days_since_last_order', align: "center", render: (h, params) => {
              const days = params.row.days_since_last_order;
              const isOverdue = days > 20;
              const displayText = days === '-' ? '无记录' : days;

              return h('span', {
                style: {
                  color: isOverdue ? 'red' : 'inherit',
                  cursor: 'help'
                },
                attrs: {
                  title: '最后一次加油距离今天天数',
                }
              }, displayText);
            }},
          {title: '站点类型',key: 'show_station_type',align: "center"},
          {
            title: '待处理调价',
            key: 'pending_apply_count',
            align: 'center',
            render: (h, params) => {
              const num = Number(params.row.pending_apply_count || 0)
              if (num > 0) {
                return h('Button', {
                  props: { type: 'warning', size: 'small' },
                  on: { click: () => { this.showPendingApplyDrawer(params.row) } }
                }, String(num))
              }
              return h('span', '0')
            }
          },
          {title: '站点',key: 'station_type_name',width:160,align: "center",render:(h,params)=>{
            let content = [];
            content.push(h('Button',{
              props: {type: 'primary', size: 'small'},
              on: {click: () => {this.showStation(params.row)}}
            }, '查看'))
            content.push(h('Button',{
              style:{marginLeft:'6px'},
              props: {type: 'warning', size: 'small'},
              on: {click: () => {this.showStationManage(params.row)}}
            }, '管理站点'))
              if (params.row.fixed_price_time){
                content.push(
                  h('p',params.row.fixed_price_time)
                )
              }
              return h('div',content)
            }},
          {title: '业务类型',key: 'is_bill',align: "center",render:(h,params)=>{
              return h('div',[
                h('p',params.row.is_bill),
              ])
            }},
          {title: '联系方式',key: 'manager_name',align: "center",width:130,render:(h,params)=>{
              return h('div',[
                h('p',params.row.manager_name),
                h('p',params.row.manager_mobile),
              ])
            }},
          {title: '单价',key: 'unit_price',align: "center",render:(h,params)=>{
              return h('a',{
                on:{click:()=> {this.showUnitPriceModal(params.row)}}
              },params.row.unit_price)
            }},
          {title: '剩余数量',key: 'balance',align: "center",render:(h,params)=>{
              return h('div',[
                h('p',[
                  h('span',params.row.pay_type_name + ' '),
                  h('a',{
                    on:{click:()=> {this.showSnDrawer(params.row)}}
                  },params.row.balance+(params.row.pay_type==='litre' ? ' L':' 元'))
                ]),
                      h('p',params.row.is_show_balance),

              ])
            }},
          /*{title: '导航次数',key: 'balance',align: "center",render:(h,params)=>{
              return h('a',{
                on:{click:()=> {this.showDaohangModal(params.row)}}
              },params.row.daohang_num)
            }},*/
          {title: '是否联动',align: "center",width:120,render:(h,params)=>{
              let status = parseInt(params.row.is_linkage)
              let content  =[];
              content.push(h('span',status===1 ? '联动' : '不联动'))

              content.push(h('Icon',
                      {
                        props:{type:'ios-repeat',size:'24',color:'red'},
                        style:{marginLeft: '5px'},
                        on:{
                          click:()=>{this.changeLinkage(params.row.company_id)}
                        }
                      }
              ))
              return h('div',content)
            }},
          {title: '加油总量',key: 'total_litre_num',align: "center"},
          {
            title: '核销余额',
            key: 'write_balance',
            render: (h, params) => {
              let write_balance = params.row.write_balance
              return h('span', {
                style: {
                  color: '#2d8cf0'
                }, on: { click: () => { this.showUnitPriceModals(params.row) } }
              }, write_balance);
            }
          },
          {
            title: '差值', key: 'diff_balance', align: 'center', render: (h, params) => {
              let diff_balance = params.row.diff_balance
              return h('span', {
                style: {
                  color: '#2d8cf0'
                }
              }, diff_balance);
            }
          },
          {
            title: '记录', align: "center", render: (h, params) => {
              let row = params.row || {}
              // const fmt = (t) => {
              //   try {
              //     const d = new Date(t)
              //     if (isNaN(d.getTime())) return '无'
              //     const pad = (n) => (n < 10 ? '0' + n : n)
              //     return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
              //   } catch (e) {
              //     return '无'
              //   }
              // }
              return h('div', [
                h('Button',
                    {
                      props: { type: 'primary', size: 'small' },
                      on: {
                        click: () => { this.writeRecord(row) }
                      },
                    }, '查看'),
                // h('div', { style: { marginTop: '6px', color: '#999', fontSize: '12px' } }, '最近核销: ' + (row.last_write_time ? fmt(row.last_write_time) : '无'))
              ])
            }
          },
          //{title: '注册时间',key: 'ctime',align: "center"},
          {title: '操作',align: "center",width:220,render:(h,params)=>{
            // 获取用户角色，只有财务(group_id=2)和超级管理员(group_id=1)可以充值
            let groupID = parseInt(sessionStorage.getItem('groupID')) || 0
            let canRecharge = (groupID === 1 || groupID === 2 || groupID === 8)
            
            let buttons = [
              h('Button',{
                props: {type: 'primary', size: 'small'},
                on: {click: () => {this.edit(params.row.company_id)}}
              }, '编辑'),
            ]
            
            // 只有财务和超级管理员显示充值按钮
            if (canRecharge) {
              buttons.push(
                h('Button',{
                  props: {type: 'primary', size: 'small'},
                  style:{marginLeft:'5px'},
                  on: {click: () => {this.showRecharge(params.row)}}
                }, '充值')
              )
            }
            
            buttons.push(
              h('Button',{
                props: {type: 'primary', size: 'small'},
                style:{marginLeft:'5px'},
                on: {click: () => {this.showPriceRuleModal(params.row)}}
              }, '调价规则'),
              h('Button',{
                props: {type: params.row.is_del === 0 ? 'error' : 'success', size: 'small'},
                style:{marginLeft:'5px'},
                on: {click: () => {
                    if(params.row.is_del === 0){
                      this.del(params.row)
                    }else{
                      this.regain(params.row)
                    }
                }}
              }, params.row.is_del === 0 ? '禁用' : '恢复')
            )
            
            return h('div', buttons)
            }},
        ],
        tableData: [],
        rechargeModal:false,
        rechargeModalTitle:'',
        loadingRechargeModal:true,
        rechargeInfo:{},
        rechargeForm:{
          company_id:0,
          amount:'',
          account_type: 2,
          password:'',
          remark:'',
        },

        isShowSnDrawer:false,
        snCompanyId:0,
        snDrawerTitle:'车队流水记录',
        unitPriceModal:{
          isShow:false,
          title:'',
          isLoading:false,
        },
        unitPriceForm:{
          company_id:0,
          doTime:'',
          unitPrice:'',
          write_balance: 0  // 添加这行
        },
        // 单价弹窗中展示的已预约尚未执行调价记录
        scheduledUnitPriceChange: null,
        // 自动调价规则弹窗
        priceRuleModal: {
          isShow: false,
          isLoading: false,
          company_id: 0,
          title: '',
          list: [],
          rangeRules: [],
          discountType: 'ndrc'
        },
        companyStationModal:{
          isShow:false,
          company_id:0,
          company_name: '',
        },
        companyStationManageModal:{
          isShow:false,
          company_id:0,
          company_name: '',
        },
        pendingApplyModal:{
          isShow:false,
          company_id:0,
          company_name:'',
        },
        writeRecordModal:{
          isShow:false,
          company_id:0,
          company_name: '',
        },
        daohangModal:{
          isShow:false,
          isLoading:false,
          company_id:0,
          title:'',
          num:'',
        },
        showEdit: false,
        tableNew:[
          {title: 'ID',key: 'id',align: "center"},
          {title: '核销金额',key: 'write_balance',align: "center"},
          {title: '相差金额',key: 'diff_balance',align: "center"},
          {title: '时间',key: 'create_time',align: "center"},
          {title: '备注',key: 'remarks',align: "center", render: (h, params) => {
              const row = params.row;
              if (row._editingRemarks) {
                return h('div', [
                  h('Input', {
                    props: { value: row._remarksDraft, maxlength: 200 },
                    style: { width: '220px', marginRight: '6px' },
                    on: { input: val => { this.$set(row, '_remarksDraft', val) } }
                  }),
                  h('Button', { props: { type: 'primary', size: 'small' }, on: { click: () => { this.saveRemarks(row) } } }, '保存'),
                  h('Button', { style: { marginLeft: '6px' }, props: { size: 'small' }, on: { click: () => { this.cancelEditRemarks(row) } } }, '取消')
                ])
              }
              return h('div', [
                h('span', row.remarks || '-'),
                h('Button', { style: { marginLeft: '8px' }, props: { type: 'primary', size: 'small' }, on: { click: () => { this.startEditRemarks(row) } } }, '编辑')
              ])
            }}
        ],
        tableNewarr:[],
        searchNew:{
          create_time:'',
          company_id:0
        },
        searchDatas:{
          platform:'',
          create_time:'',
          company_id:0
        }
      }
    },
    methods: {
      inArray(value, list) {
        if (!Array.isArray(list)) return false
        const normalizedValue = String(value)
        return list.some(item => String(item) === normalizedValue)
      },
      sanitizeNumericText(val, allowNegative = false) {
        let text = val === undefined || val === null ? '' : String(val)
        text = text.replace(allowNegative ? /[^\d.\-]/g : /[^\d.]/g, '')
        if (allowNegative) {
          text = text.replace(/(?!^)-/g, '')
        }
        const parts = text.split('.')
        if (parts.length > 2) {
          text = `${parts.shift()}.${parts.join('')}`
        }
        if (text.startsWith('.')) text = `0${text}`
        if (text.startsWith('-.')) text = text.replace('-.', '-0.')
        return text
      },
      formatMoneyInput(val, allowNegative = false) {
        const text = this.sanitizeNumericText(val, allowNegative)
        if (!text) return ''
        const num = Number(text)
        if (Number.isNaN(num)) {
          this.$Message.warning('请输入数字金额')
          return ''
        }
        return num.toFixed(2)
      },
      onRangeInput(index, field, val) {
        const list = this.priceRuleModal.rangeRules || []
        if (!list[index]) return
        this.$set(list[index], field, this.sanitizeNumericText(val, false))
      },
      onRangeBlur(index, field) {
        const list = this.priceRuleModal.rangeRules || []
        if (!list[index]) return
        const current = list[index][field]
        if (current === '' || current === null || current === undefined) return
        this.$set(list[index], field, this.formatMoneyInput(current, false))
      },
      onWriteBalanceInput(val) {
        this.unitPriceForm.write_balance = this.sanitizeNumericText(val, true)
      },
      onWriteBalanceBlur() {
        const current = this.unitPriceForm.write_balance
        if (current === '' || current === null || current === undefined) return
        this.unitPriceForm.write_balance = this.formatMoneyInput(current, true)
      },
      cancelEdit(){
        this.showEditForm = false
        this.editCompanyId = 0
      },
      editSuccess(){
        this.$refs.table.getLists();
        this.showEditForm = false
        this.editCompanyId = 0
      },
      edit(company_id){
        this.showEditForm = true
        this.editCompanyId = company_id
      },
      showRecharge(company_info){
        this.rechargeModal = true
        this.rechargeModalTitle = company_info.company_name + ' 充值'
        this.rechargeForm.company_id = company_info.company_id
        // 默认充值到全账户
        this.rechargeForm.account_type = 2
        this.rechargeInfo = company_info
      },
      cancelRechargeModal(){
        this.rechargeModal = false
        this.rechargeForm.company_id = 0
        this.rechargeInfo = {}
      },
      // 点击“未付款”按钮，将“未付款”填入备注
      fillRemarkUnpaid(){
        this.rechargeForm.remark = '未付款'
        this.$Message.success('已填入备注：未付款')
      },
      async doRecharge(){
        if (this.rechargeForm.company_id<=0 || this.rechargeForm.amount==0){
          return this.$commonFun.errorTip('请输入正确的金额')
        }
        let res = await this.$commonFun.postProxy('admin/company/rechargeCompany',this.rechargeForm);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.rechargeModal = false
            this.rechargeForm.company_id = 0
            this.rechargeForm.account_type = 0
            this.$refs.table.getLists();
          })
        })
      },

      showSnDrawer(info){
        this.isShowSnDrawer = true
        this.snCompanyId = info.company_id
        this.snDrawerTitle = info.company_name
      },
      showPendingApplyDrawer(info){
        this.pendingApplyModal.isShow = true
        this.pendingApplyModal.company_id = info.company_id
        this.pendingApplyModal.company_name = info.company_name
      },
      closePendingApplyDrawer(){
        this.pendingApplyModal.isShow = false
        this.pendingApplyModal.company_id = 0
        this.pendingApplyModal.company_name = ''
      },
      showDaohangModal(info){
        this.daohangModal.isShow = true
        this.daohangModal.company_id = info.company_id
        this.daohangModal.title = info.company_name
      },
      cancelDaohangModal(){
        this.daohangModal.isShow = false
        this.daohangModal.company_id = 0
      },
      closeSnDrawer(){
        this.isShowSnDrawer = false
        this.snCompanyId = 0
      },
      async del(info){
        this.$Modal.confirm({
          title:'禁用',
          content:`确定要禁用车队:${info.company_name} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/company/delCompany',{id:info.company_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })

      },
      async changePayType(){
        let params = {
          company_id:this.rechargeForm.company_id,
          pay_type:this.rechargeInfo.pay_type
        }
        this.$Modal.confirm({
          title:'修改支付方式',
          content:`修改后原有余额将清 0，确定要修改吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/company/changePayType',params);
            this.$Modal.remove()
            this.cancelRechargeModal()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })
      },
      async regain(info){
        this.$Modal.confirm({
          title:'恢复',
          content:`确定要恢复车队:${info.company_name} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/company/regainCompany',{id:info.company_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })

      },
      //根据填写的金额计算剩余数量
      countCompanyBalance(){
        let amount = this.rechargeForm.amount
        let num = parseFloat(amount/this.rechargeInfo.unit_price).toFixed(2)
        let after_amount = (parseFloat(this.rechargeInfo.company_balance) + parseFloat(num)).toFixed(2)
        this.editAfterCompanyBalance = after_amount
      },
      async showUnitPriceModal(company_info){
        this.scheduledUnitPriceChange = null
        // 获取当前车队已预约尚未执行的调价记录（如有）
        try {
          let exist = await this.$commonFun.postProxy('admin/company/getUnitPriceFixTime',{company_id:company_info.company_id});
          if (exist && exist.code === 200 && exist.data) {
            this.scheduledUnitPriceChange = {
              old_unit_price: exist.data.old_unit_price,
              new_unit_price: exist.data.new_unit_price,
              do_time: exist.data.do_time,
            }
          }
        } catch (e) {
          this.scheduledUnitPriceChange = null
        }
        this.unitPriceModal.isShow = true
        this.unitPriceModal.title = company_info.company_name + ' 单价修改'
        this.unitPriceForm.company_id=company_info.company_id
        this.unitPriceForm.unitPrice = company_info.unit_price
        this.unitPriceForm.doTime = ''
      },
      cancelUnitPriceModal(){
        this.unitPriceModal.isShow = false
        this.unitPriceForm.company_id=0
        this.unitPriceForm.unitPrice = ''
        this.unitPriceForm.doTime = ''
        this.scheduledUnitPriceChange = null
      },
      async changeUnitPriceFixTime(){
        if (this.unitPriceForm.company_id<=0 || this.unitPriceForm.unitPrice<=0){
          return this.$commonFun.errorTip('请输入正确的金额')
        }
        let res = await this.$commonFun.postProxy('admin/company/changeUnitPriceFixTime',this.unitPriceForm);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.unitPriceModal.isShow = false
            this.unitPriceForm.company_id=0
            this.unitPriceForm.unitPrice = ''
            this.unitPriceForm.doTime = ''
            this.scheduledUnitPriceChange = null
            this.$refs.table.getLists();
          })
        })
      },
      async editDaohangNum(){
        this.daohangModal.isLoading = true
        let res = await this.$commonFun.postProxy('admin/company/editDaohangNum',{company_id:this.daohangModal.company_id,num:this.daohangModal.num});
        this.daohangModal.isLoading = false
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.$refs.table.getLists();
          })
        })
      },
      showStation(info){
        this.companyStationModal.isShow = true
        this.companyStationModal.company_id = info.company_id
        this.companyStationModal.company_name = info.company_name
      },
      showStationManage(info){
        this.companyStationManageModal.isShow = true
        this.companyStationManageModal.company_id = info.company_id
        this.companyStationManageModal.company_name = info.company_name
      },
      writeRecord(info){
        this.writeRecordModal.isShow = true
        this.writeRecordModal.company_id = info.company_id
        this.writeRecordModal.company_name = info.company_name+' 核销记录'
        // 设置搜索参数中的company_id
        this.searchNew.company_id = info.company_id
        this.searchDatas.company_id = info.company_id
        this.getWriteRecord();
      },
     // 添加新的方法来获取核销记录
      async getWriteRecord() {
        // 调用 API 获取核销记录
        let res = await this.$commonFun.postProxy('admin/company/getWriteRecord', this.searchNew);
        this.$commonFun.dealApiResult(res, () => {
          this.tableNewarr = res.data;
        });
      },
      async exportData(){
        let res = await this.$commonFun.postProxy('admin/company/exportCompany',this.searchData)
        this.$commonFun.dealApiResult(res,()=>{
          let worksheet = XLSX.utils.aoa_to_sheet(res.data)
          let workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
          XLSX.writeFile(workbook,`车队信息.xlsx`)
        })
      },

      async changeLinkage(company_id){
        this.$Modal.confirm({
          content:`确定要修改吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/company/changeLinkage',{company_id});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
        })
      },
      // 打开自动调价规则弹窗
      async showPriceRuleModal(company_info) {
        this.priceRuleModal.isLoading = true;
        this.priceRuleModal.company_id = company_info.company_id;
        this.priceRuleModal.title = company_info.company_name + ' 自动调价规则';
        const defaults = [
          { id: 1, name: '不超过挂牌价', enabled: false, params: { oil_enabled: 1, lng_enabled: 1 } },
          { id: 2, name: '不超过油机价', enabled: false, params: { oil_enabled: 1, lng_enabled: 1 } },
          { id: 3, name: '无优惠时加价', enabled: false, params: { oil_add: 0, lng_add: 0 } },
          { id: 6, name: '油站固定结算价加价X，LNG加价Y', enabled: false, params: { oil_add: 0, lng_add: 0 } },
          { id: 8, name: '挂牌价 - 油机价 > X 时，加价 Y', enabled: false, params: { threshold: 0, add: 0 } },
        ];
        try{
          const res = await this.$commonFun.postProxy('admin/company/getPriceRule', { company_id: company_info.company_id });
          let price_rule = [];
          let range_rules = [];
          let discount_type = 'ndrc';
          let exist = [];
          if (res && res.code === 200) {
            if (Array.isArray(res.data)) {
              price_rule = res.data || [];
            } else {
              price_rule = res.data.price_rule || [];
              range_rules = res.data.range_rules || [];
              discount_type = res.data.discount_type || 'ndrc';
            }
          }
          try {
            exist = Array.isArray(price_rule) ? price_rule : (price_rule ? JSON.parse(price_rule) : []);
          } catch (e) {
            exist = [];
          }
          if (Array.isArray(exist) && exist.length > 0) {
            const map = {}; exist.forEach(it => { map[it.rule_id || it.id] = it; });
            this.priceRuleModal.list = defaults.map(item => {
              const src = map[item.id];
              if (!src) return item;
              // build params from returned row
              const params = {};
              if (src.threshold !== undefined) params.threshold = src.threshold;
              if (src.add !== undefined) params.add = src.add;
              if (src.sub !== undefined) params.sub = src.sub;
              if (src.oil_add !== undefined) params.oil_add = src.oil_add;
              if (src.lng_add !== undefined) params.lng_add = src.lng_add;
              if ([1, 2].includes(item.id)) {
                const oilFlag = Number(src.oil_add);
                const lngFlag = Number(src.lng_add);
                // 兼容旧数据：历史版本未区分油/气时，这两个字段可能均为 0，按双端都启用处理
                if (oilFlag === 0 && lngFlag === 0) {
                  params.oil_enabled = 1;
                  params.lng_enabled = 1;
                } else {
                  params.oil_enabled = oilFlag > 0 ? 1 : 0;
                  params.lng_enabled = lngFlag > 0 ? 1 : 0;
                }
              }
              if (item.id === 3) {
                const oilAdd = src.oil_add !== undefined && src.oil_add !== null ? Number(src.oil_add) : null;
                const lngAdd = src.lng_add !== undefined && src.lng_add !== null ? Number(src.lng_add) : null;
                const baseAdd = src.add !== undefined && src.add !== null ? Number(src.add) : 0;
                if (baseAdd > 0 && (oilAdd === 0 || oilAdd === null) && (lngAdd === 0 || lngAdd === null)) {
                  // 兼容旧数据：历史 rule3 仅存 add，oil_add/lng_add 可能为 0
                  params.oil_add = baseAdd;
                  params.lng_add = baseAdd;
                } else {
                  params.oil_add = oilAdd === null ? baseAdd : oilAdd;
                  params.lng_add = lngAdd === null ? baseAdd : lngAdd;
                }
              }
              return Object.assign({}, item, { enabled: true, params });
            });
          } else {
            this.priceRuleModal.list = defaults;
          }

          this.priceRuleModal.rangeRules = (range_rules || []).map(it => ({
            min_discount: it.min_discount === null || it.min_discount === undefined ? 0 : Number(it.min_discount),
            max_discount: it.max_discount === null || it.max_discount === undefined || it.max_discount === '' ? null : Number(it.max_discount),
            add_price: it.add_price === null || it.add_price === undefined ? 0 : Number(it.add_price),
            oil_add: it.oil_add === null || it.oil_add === undefined || it.oil_add === '' ? null : Number(it.oil_add),
            lng_add: it.lng_add === null || it.lng_add === undefined || it.lng_add === '' ? null : Number(it.lng_add),
          }));
          this.priceRuleModal.discountType = discount_type === 'station' ? 'station' : 'ndrc';
        }catch(e){
          this.priceRuleModal.list = defaults;
          this.priceRuleModal.rangeRules = [];
          this.priceRuleModal.discountType = 'ndrc';
        }finally{
          this.priceRuleModal.isLoading = false;
          this.priceRuleModal.isShow = true;
        }
      },

      addRangeRule(){
        this.priceRuleModal.rangeRules.push({
          min_discount: 0,
          max_discount: null,
          add_price: 0,
          oil_add: null,
          lng_add: null,
        })
      },

      removeRangeRule(index){
        this.priceRuleModal.rangeRules.splice(index, 1)
      },

      validateRangeRules(){
        const list = (this.priceRuleModal.rangeRules || []).map(it => ({ ...it }))
        for (let i = 0; i < list.length; i++) {
          const item = list[i]
          const min = Number(item.min_discount)
          const hasMax = item.max_discount !== null && item.max_discount !== '' && item.max_discount !== undefined
          const max = hasMax ? Number(item.max_discount) : null
          if (Number.isNaN(min)) return '区间下界必须是数字'
          if (hasMax && Number.isNaN(max)) return '区间上界必须是数字'
          if (hasMax && max <= min) return '区间上界必须大于下界'
        }
        list.sort((a, b) => Number(a.min_discount) - Number(b.min_discount))
        for (let i = 1; i < list.length; i++) {
          const prev = list[i - 1]
          const curr = list[i]
          const prevHasMax = prev.max_discount !== null && prev.max_discount !== '' && prev.max_discount !== undefined
          const prevMax = prevHasMax ? Number(prev.max_discount) : null
          const currMin = Number(curr.min_discount)
          if (!prevHasMax || prevMax > currMin) {
            return '优惠区间不能重叠'
          }
        }
        return ''
      },

      cancelPriceRuleModal(){
        this.priceRuleModal.isShow = false;
        this.priceRuleModal.list = [];
        this.priceRuleModal.rangeRules = [];
        this.priceRuleModal.discountType = 'ndrc';
        this.priceRuleModal.company_id = 0;
      },

      async savePriceRule(){
        const company_id = this.priceRuleModal.company_id;
        if (company_id<=0) return this.$Modal.error({title:'错误',content:'参数错误'});
        const rangeErr = this.validateRangeRules()
        if (rangeErr) return this.$Modal.error({title:'错误',content:rangeErr});
        const payload = this.priceRuleModal.list.map(it=>({rule_id:it.id,enabled: it.enabled?1:0,...it.params||{}}));
        const rangePayload = (this.priceRuleModal.rangeRules || []).map((it, idx)=>(
          {
            min_discount: it.min_discount === null || it.min_discount === '' ? 0 : Number(it.min_discount),
            max_discount: it.max_discount === null || it.max_discount === '' ? null : Number(it.max_discount),
            add_price: it.add_price === null || it.add_price === '' ? 0 : Number(it.add_price),
            oil_add: it.oil_add === null || it.oil_add === '' ? null : Number(it.oil_add),
            lng_add: it.lng_add === null || it.lng_add === '' ? null : Number(it.lng_add),
            priority: idx + 1,
          }
        ));
        this.priceRuleModal.isLoading = true;
        try{
          const res = await this.$commonFun.postProxy('admin/company/setPriceRule',{
            company_id,
            price_rule:payload,
            range_rules:rangePayload,
            discount_type:this.priceRuleModal.discountType || 'ndrc',
          });
          this.$commonFun.dealApiResult(res,()=>{
            this.$commonFun.successTip(res.msg || '保存成功',()=>{
              this.priceRuleModal.isShow = false;
              this.priceRuleModal.isLoading = false;
              this.$refs.table.getLists && this.$refs.table.getLists();
            })
          },()=>{ this.priceRuleModal.isLoading = false; });
        }catch(e){
          this.priceRuleModal.isLoading = false;
          this.$Message.error('保存失败');
        }
      },
      //核销记录
      showUnitPriceModals(company_info) {
        this.unitPriceModals.isShow = true
        this.unitPriceModals.title = '核销'
        this.unitPriceForm.company_id = company_info.company_id
        this.unitPriceForm.balances = ''
      },
      async balanceSecWrite() {
        const writeBalance = Number(this.unitPriceForm.write_balance)
        if (Number.isNaN(writeBalance)) {
          return this.$commonFun.errorTip('请输入正确的核销金额')
        }
        const payload = {
          ...this.unitPriceForm,
          write_balance: writeBalance
        }
        let res = await this.$commonFun.postProxy('admin/company/writeRecord', payload);
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.unitPriceModals.isShow = false
            this.unitPriceForm.company_id = 0
            this.unitPriceForm.balances = ''
            this.$refs.table.getLists();
            this.$commonFun.successTip(res.msg)
            // this.$refs.table.getLists();
          })
        })
      },
      cancelUnitPriceModals() {
        this.unitPriceModals.isShow = false
        this.unitPriceForm.company_id = 0
        this.unitPriceForm.balances = ''
      },
      timeChange(time) {
        if(time[1].slice(-8)==='00:00:00'){
          time[1] = time[1].slice(0,-8) + '23:59:59'
          this.searchDatas.create_time = time
          this.searchData.create_time = time
          this.searchNew.create_time = time
          // 确保company_id不会丢失
          this.searchNew.company_id = this.writeRecordModal.company_id
        }
      },
      startEditRemarks(row){
        this.$set(row, '_editingRemarks', true);
        this.$set(row, '_remarksDraft', row.remarks || '');
      },
      // 取消编辑
      cancelEditRemarks(row){
        this.$set(row, '_editingRemarks', false);
        this.$set(row, '_remarksDraft', undefined);
      },
      // 保存备注（新增或编辑）
      async saveRemarks(row){
        let payload = {
          id: row.id,
          remarks: row._remarksDraft || ''
        }
        try{
          let res = await this.$commonFun.postProxy('admin/site_balance/editRecord', payload);
          this.$commonFun.dealApiResult(res, ()=>{
            this.$Message.success(res.msg || '保存成功');
            // 更新本地展示
            this.$set(row, 'remarks', payload.remarks);
            this.$set(row, '_editingRemarks', false);
            this.$set(row, '_remarksDraft', undefined);
          })
        }catch(e){
          // 可选错误处理
        }
      },
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
